import { ArrowLeft, ArrowRight, ChevronDown } from 'lucide-react';
import { useState } from 'react';
import faqs from '../../data/faq';
import { cn } from '../../lib/utils';

// Função auxiliar para combinar classes condicionalmente

const ITEMS_PER_PAGE = 5;

const FaqBlock = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const startIndex = currentPage * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const currentFaqs = faqs.slice(startIndex, endIndex);

  const handleNext = () => {
    if (endIndex < faqs.length) {
      setCurrentPage(currentPage + 1);
      setExpandedIndex(null);
    }
  };

  const handlePrevious = () => {
    if (startIndex > 0) {
      setCurrentPage(currentPage - 1);
      setExpandedIndex(null);
    }
  };

  const toggleAccordion = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div
      id='duvidas'
      className='px-8 py-40 lg:pt-40 lg:pb-40 justify-center items-start lg:gap-[120px] gap-[20px] md2:inline-flex bg-main-color w-full'
    >
      <div className='flex-col justify-start items-start lg:max-w-[100%] gap-4 lg:gap-11 inline-flex pb-16'>
        <div className='flex-col justify-start items-start gap-5 flex'>
          <div className='max-w-[337px] pt-[1.85px] justify-start items-center flex'>
            <span className='text-sm text-left font-normal leading-normal'>
              Tire suas dúvidas sobre o Benefício Thopen TIM.
            </span>
          </div>
        </div>
        <div className='lg:text-[36.88px] text-[30.88px] text-left font-light leading-[54px]'>
          Sobre o que você <br className='hidden xl:block' /> quer saber?
        </div>
      </div>

      <div className='max-w-[702px] flex-col justify-end items-start gap-5 inline-flex'>
        <div
          id='duvidas'
          className='h-4 pl-2 text-[15px] font-semibold leading-none'
        >
          Principais dúvidas
        </div>
        <div className='flex-col justify-start gap-3 items-end flex w-full'>
          {currentFaqs.map((faq, index) => (
            <div className='w-full ' key={index}>
              <div className='w-[95%] m-auto h-[1px] bg-white'></div>
              <div className='w-full py-4 pl-4 pr-[13.79px] border-t border-[#696969]/10 justify-center items-center inline-flex mt-3'>
                <div className='w-full'>
                  <button
                    onClick={() => toggleAccordion(index)}
                    className='flex justify-between items-center w-full text-left'
                    aria-expanded={expandedIndex === index}
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                  >
                    <span>{faq.summary}</span>
                    <ChevronDown
                      className={cn(
                        'transition-transform duration-200',
                        expandedIndex === index ? 'transform rotate-180' : ''
                      )}
                      size={24}
                    />
                  </button>
                  <div
                    id={`panel${index + 1}-content`}
                    role='region'
                    aria-labelledby={`panel${index + 1}-header`}
                    className={cn(
                      'overflow-hidden transition-all duration-300',
                      expandedIndex === index ? 'max-h-96' : 'max-h-0'
                    )}
                  >
                    <div className='space-y-3 text-left pt-4'>
                      <div className='w-full flex justify-start items-start pl-2 gap-3'>
                        <p>•</p>
                        <p dangerouslySetInnerHTML={{ __html: faq.details }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className='w-[95%] m-auto h-[1px] bg-white'></div>
          <div className='flex flex-col md:flex-row items-center gap-6 w-full pt-20 justify-start'>
            <span>Consultar todas as dúvidas</span>

            <div className='flex gap-5'>
              <button
                onClick={handlePrevious}
                disabled={currentPage === 0}
                className={cn(
                  'flex items-center justify-center w-14 h-14 rounded-full border-2',
                  currentPage === 0
                    ? 'hidden md:invisible'
                    : 'border-white text-white'
                )}
                aria-label='Anterior'
              >
                <a href='#duvidas' aria-label='Voltar'>
                  <ArrowLeft size={24} />
                </a>
              </button>
              <button
                onClick={handleNext}
                disabled={endIndex >= faqs.length}
                className={cn(
                  'flex items-center justify-center w-16 h-16 rounded-full border-2',
                  endIndex >= faqs.length
                    ? 'hidden md:invisible'
                    : 'border-white text-white'
                )}
                aria-label='Próximo'
              >
                <a href='#duvidas' aria-label='Avançar'>
                  <ArrowRight size={24} />
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqBlock;
